module.exports = __webpack_public_path__ + "static/scale-model-of-torrance-california-070a3c7f6b7fec961bd28b80b8f3fe55.png";